import React, { Component } from "react";

class ForecastActivator extends Component {
  render() {
    const { channel } = this.props;

    const purchaseActivation = async () => {
      const orderResponse = await fetch("/api/orders", {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              productId: "ACTIVATE_FORECASTS",
              quantity: "1",
              data: { channelId: channel.id },
            },
          ],
        }),
      });

      if (!orderResponse.ok) {
        if (orderResponse.status === 401) {
          // redirect to login
          window.location.href = `${
            window.location.origin
          }/login?ref=${encodeURIComponent(window.location.pathname)}`;
        }

        // TODO: display error
        return;
      }

      const order = await orderResponse.json();

      window.location.href = `${window.location.origin}/orders/${order.id}`;
    };

    return (
      <div style={{ flexBasis: "100%" }}>
        <h4 style={{ padding: "4px" }}>Forecasts</h4>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div onClick={purchaseActivation} className="btn primary">
            Activate
          </div>
        </div>
      </div>
    );
  }
}

export default ForecastActivator;
